import dayjs from 'dayjs';
import parser from 'dayjs/plugin/customParseFormat';
import formatter from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/pt-br';

export const DATE_FORMAT_CHARS_INTERNATIONAL = 'YYYY-MM-DD';
export const DATE_FORMAT_CHARS = 'DD/MM/YYYY';
export const DATE_FORMAT = '##/##/####';

dayjs.extend(parser);
dayjs.extend(formatter);
dayjs.locale('pt-br');

export default function date(value = '', options = {}) {
  if (['', undefined, null].includes(value)) {
    return false;
  }

  if (dayjs(value, options.format || DATE_FORMAT_CHARS, true).isValid()) {
    return false;
  }

  return true;
}

date.message = function message(value, options = {}) {
  return options.message || 'precisa ser uma data válida';
};
